import { EMoneySource } from '../../../../redux/reducers';

export const MoneySourceOptions = [
  {
    label: 'Агентство',
    value: EMoneySource.Master,
  },
  {
    label: 'Личный',
    value: EMoneySource.Self,
  },
];
